import React, {ReactNode} from 'react';
import cx from 'classnames';
import {Button} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {Loader} from '../Loader/index';

type Props = {
    children?: ReactNode;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    componentClasses?: string;
};

export const SubmitButton = ({
    loading,
    componentClasses = '',
    children,
    onClick,
    disabled
}: Props) => {
    const classes = cx(styles.component, componentClasses, {
        [styles.loading]: loading
    });

    return (
        <Button
            disabled={disabled || loading}
            size="small"
            skin="primary"
            suffixIcon={loading && <Loader componentClasses={styles.loader} />}
            onClick={onClick}
            componentClasses={classes}
        >
            {children}
        </Button>
    );
};
